import React, { useState } from "react";
import Modal from "../Modal/index";

const ProjectCard = () => {
  const photos = [
    {
      name: "Sparkify Data Modeling with PostgreSQL",
      description:
        "Designed a PostgreSQL star schema and built an ETL pipeline to load JSON song metadata and user activity logs into fact and dimension tables for analytics. Includes automated database/table setup and a reproducible local run workflow.",
      stack:
        "PostgreSQL, Python, psycopg2, pandas, SQL",
      caption: "Star schema + ETL in PostgreSQL",
      github: "https://github.com/BlinkingHeimdall/Sparkify-Data-Modeling-with-PosgreSQL",
      deployment:
        "",
    },
    {
      name: "Airline Delays Dashboard",
      description:
        "Exploratory data analysis of U.S. airline delays and cancellations using Tableau. Includes (1) worst airports by average arrival delay map (2015), (2) cancellations heatmap, and (3) a dashboard analyzing delay rates by airline and cause of delay across interactive views.",
      stack:
        "Tableau, Exploratory Data Analysis (EDA), Data Visualization, Dashboard Design",
      caption: "Tableau EDA",
      github: "",
      deployment: "https://public.tableau.com/app/profile/jason.adams5598/viz/JasonAdamsWGUD500DataVisualization/FlightDelaysDashboard?publish=yes",
    },
    {
      name: "Predicting LEGO Investment Performance",
      description:
        "Applied exploratory data analysis and machine learning to predict after-market value of LEGO sets using historical pricing and set features. Includes data cleaning, feature engineering, regression and classification models, and model evaluation.",
      stack:
        "Python, pandas, scikit-learn, matplotlib, seaborn, Jupyter Notebook",
      caption: "LEGO Investment Analytics Capstone",
      github: "https://github.com/BlinkingHeimdall/Predicting-LEGO-Investment-Values-with-Historical-Price-Data",
      deployment: "",
    },
    {
      name: "A/B Test Analysis Conversion Experiment",
      description:
        "Analyzed results from an A/B experiment to evaluate whether a proposed change affected conversion. Performed data validation, simulation-based hypothesis testing, and logistic regression to confirm inference and support a rollout decision.",
      stack:
        "Python, pandas, numpy, statsmodels, matplotlib, Jupyter Notebook",
      caption: "A/B Testing",
      github: "https://github.com/BlinkingHeimdall/A-B-Test-Analysis-Conversion-Experiment",
      deployment: "",
    }
  ];

  const [isModalOpen, setIsModalOpen] = useState(false);

  const [currentPhoto, setCurrentPhoto] = useState();

  const toggleModal = (image, i) => {
    setCurrentPhoto({ ...image, index: i });
    setIsModalOpen(!isModalOpen);
  };

  return (
    <section>
      <div>
        {isModalOpen && (
          <Modal currentPhoto={currentPhoto} onClose={toggleModal} />
        )}
      </div>
      <div className="project-row">
        {photos.map((image, i) => (
          <div className="project-img" key={i}>
            <p className="project-name" onClick={() => toggleModal(image, i)}>
              {image.caption}
            </p>
            {/* <img
              src={require(`../../assets/projects/${i}.jpg`).default}
              alt={image.name}
            /> */}
          </div>
        ))}
      </div>
    </section>
  );
};

export default ProjectCard;
